import { request } from '../apis/';

export interface PublicHolidayUploadResponse {
  status: string;
  message: string;
  totalRowsInExcel: number;
  successfulUploads: number;
  skippedRows: number;
  errors: string[];
  skippedHolidays: string[];
}

export const PublicHolidayService = {
  uploadPublicHolidays: (file: File, year: number) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('year', year.toString());

    return request.post<PublicHolidayUploadResponse>(
      'PublicHolidayUpload/upload',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
  }
};
